import { useEffect, useRef } from "react"
import { addToast } from "@heroui/react"
import { useFeatureLock } from "./useFeatureLock"
import { KeyRound } from 'lucide-react';
import { useSelector } from "react-redux";

export const useFeatureUnlockToasts = () => {
    const { materialsLocked, chatLocked } = useFeatureLock()
    const onboardingStep = useSelector((state) => state.onboardingStep ?? "welcome")
    const shownThisSession = useRef(new Set())

    const checkUnlock = (show, id, title, description) => {
        const key = `unlock-toast-${id}`
        const dismissed = localStorage.getItem(key) === 'true'

        if (show && !dismissed && !shownThisSession.current.has(id)) {
            shownThisSession.current.add(id)
            addToast({
                title,
                description,
                radius: "lg",
                timeout: 10000,
                classNames: {
                    bbase: "bg-white/50 dark:bg-white/10 backdrop-blur-md dark:border-white/10",
                    description: "font-light text-base-text",
                    title: "font-normal text-base-text",
                    icon: "fill-white/0"
                },
                icon: <KeyRound className="text-base-text size-5" strokeWidth={1} />,
                onClose: () => localStorage.setItem(key, 'true')
            })
        }
    }

    // useEffect(() => {
    //     checkUnlock(
    //         !materialsLocked && onboardingStep === "materials-page",
    //         "materials",
    //         "新しい機能が解除されました",
    //         "教材タブが利用可能になりました。"
    //     )
    // }, [materialsLocked, onboardingStep])

    useEffect(() => {
        checkUnlock(
            !chatLocked,
            "chat",
            "新しい扉が、開きました。",
            "アオメとの対話が、始まります。"
        )
    }, [chatLocked])
}